import { CSSObject } from '@emotion/react'
import { sharedColors } from '../sharedDisplays/sharedStyles/colors'

type DisplayProps = {
  [key: string]: number
}

const renderDisplayLayout: DisplayProps = {
  desktopSingle: 600,
  mobileSingle: 375,
  desktopStream: 600,
  mobileStream: 375,
}

const baseStyles = (display: string, postType: string): CSSObject => ({
  backgroundColor: '#fff',
  border: postType === 'moment' ? sharedColors.momentBorder : 'none',
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  width:
    postType === 'moment'
      ? `calc(${renderDisplayLayout[display]}px - 2px)`
      : renderDisplayLayout[display],
})

export { baseStyles }
